/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFortnite = createReactComponent("brand-fortnite", "IconBrandFortnite", [
  ["path", { d: "M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1z", key: "svg-0" }]
]);

export { IconBrandFortnite as default };
//# sourceMappingURL=IconBrandFortnite.js.map
